<template>
<div>
  <div class="vx-row">
  <div class="vx-col w-full">
    <div
      v-if="banner.path"
      class="container w-full mx-auto bg-white bg-center bg-cover bg-no-repeat md:rounded"
      :style="{
        'background-image': 'url(' + banner.path + ')',
        height: '48vh',
        position: 'relative',
        zIndex: '1',
        'max-height': '200px',
      }"
    ></div>
    </div>
    <div class="vx-col w-full mt-5">
      <h3 class="mb-4"><strong>{{ $t('banner.GeneralInfo') }}</strong></h3>
    </div>
    <div class="vx-col md:w-1/2 w-full">
      <div class="vx-col w-full mb-3">
        <label><strong>URL</strong></label>
        <p>{{ banner.url }}</p>
      </div>
    </div>
    <div class="vx-col md:w-1/2 w-full">
      <div class="vx-col w-full mb-3">
        <label><strong>{{ $t('banner.Status') }}</strong></label>
        <p v-if="banner.active">{{ $t('banner.Activated') }}</p>
        <p v-if="!banner.active">{{ $t('banner.Deactivated') }}</p>
      </div>
    </div>
    <div class="vx-col md:w-1/2 w-full">
      <div class="vx-col w-full mb-3">
        <label><strong>{{ $t('FechaDesde') }}</strong></label>
        <p>{{ banner.started_at }}</p>
      </div>
    </div>
    <div class="vx-col md:w-1/2 w-full">
      <div class="vx-col w-full mb-3">
        <label><strong>{{ $t('FechaHasta') }}</strong></label>
        <p v-if="!isPermanent">{{ banner.finished_at }}</p>
        <p v-if="isPermanent">{{ $t('banner.AlwaysBannerText')  }}</p>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  export default {
    props: {
      banner: {
        type: Object,
        required: true,
      }
    },
    data() {
      return {
        isPermanent: false
      }
    },
    created() {
      const noFinished = this.banner.finished_at === '9999-12-31' || this.banner.finished_at === null;

      if (noFinished) {
        this.isPermanent = true;
      }
    },
    destroyed() {
      this.$store.commit('setpopupSeeBanner', false);
    }
}
</script>
<style>
</style>
